import { useUser } from "@clerk/clerk-expo";
import { useToken } from "@gluestack-style/react";
import { Box, Button, FormattedCurrency, HStack, Icon, ParagraphSmall, Text } from "components/ui";
import { useRouter } from "expo-router";
import { ShoppingCart, TriangleAlert } from "lucide-react-native";
import React from "react";
import { useGetCartCurrentQuery } from "store/abcoApi";
import { ShippingType } from "types/constants.type";
import { truncateText } from "utils/globalFunctions";
import { useSiteSearch } from "utils/hooks/useSiteSearch";
type Props = {
	closeSearch?: boolean;
};
const ButtonCart = ({ closeSearch }: Props) => {
	const { data: cart, isLoading, isFetching, isError, error, currentData } = useGetCartCurrentQuery();
	const { isSignedIn, user } = useUser();
	const { close } = useSiteSearch();
	const resolvedWarningMain = useToken("colors", "warningmain");

	const router = useRouter();
	const handlePress = () => {
		if (closeSearch) {
			close();
		}
		router.push("/(pages)/(inner)/cart/(step1)");
	};

	if (isLoading || cart == null) {
		return null;
	}
	return (
		<Button flexDirection="row" h="$full" alignItems="center" py={9} px={24} borderRadius={12} backgroundColor="$primarylight" onPress={handlePress}>
			<Icon as={ShoppingCart} color="$basicwhite " mr={18} size="xl" />
			<Text display="flex" alignItems="baseline" flexDirection="column" color="$basicwhite">
				{cart?.shippingType !== ShippingType.Pickup ? (
					cart?.siteId ? (
						<Text size="md" color="$basicwhite">
							{truncateText(cart.siteName as string)}
						</Text>
					) : (
						isSignedIn && (
							<HStack mb={4} alignItems="center" gap={6}>
								<TriangleAlert color={resolvedWarningMain} size={16} />
								<Box borderBottomWidth={1} borderColor={"white"} pb={0}>
									<ParagraphSmall color={"white"}>Select site</ParagraphSmall>
								</Box>
							</HStack>
						)
					)
				) : cart?.pickupLocationId ? (
					<Text size="md" color="$basicwhite">
						{truncateText(cart.pickupLocationName as string)}
					</Text>
				) : (
					isSignedIn && (
						<HStack mb={4} alignItems="center" gap={6}>
							<TriangleAlert color={resolvedWarningMain} size={16} />
							<Box borderBottomWidth={1} borderColor={"white"} pb={0}>
								<ParagraphSmall color={"white"}>Select pickup location</ParagraphSmall>
							</Box>
						</HStack>
					)
				)}

				<FormattedCurrency
					sx={{
						color: "$basicwhite",
						fontWeight: "bold",
						fontSize: 16,
						marginLeft: "auto",
					}}
					amount={cart?.totalAmount}
				/>
			</Text>
		</Button>
	);
};

export default ButtonCart;
